'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _EventEmitter2 = _interopRequireDefault(require('../EventEmitter'))
var _is = require('../is')
var _misc = require('./misc')

var _convert = _interopRequireDefault(require('./convert'))
var _utils = require('./utils')
var _innerUtils = require('./innerUtils')

var _getters = require('./getters')

var _setters = require('./setters')

var _setTimePartToStartEnd2 = _interopRequireDefault(require('./setTimePartToStartEnd'))
var TimeDate = /*#__PURE__*/ (function(_EventEmitter) {
  ;(0, _inheritsLoose2.default)(TimeDate, _EventEmitter)
  TimeDate.fromNow = function fromNow() {
    return new TimeDate((0, _getters.getNow)())
  }
  TimeDate.from = function from(arg) {
    return new TimeDate(arg)
  }

  function TimeDate(arg) {
    var _this
    _this = _EventEmitter.call(this) || this
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), '_date', void 0)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), '_min', null)
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), '_max', null)
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'minObj',
      (0, _innerUtils.nullableDateObj)()
    )
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'maxObj',
      (0, _innerUtils.nullableDateObj)()
    )
    var d = _convert.default.fromWhatever(arg)
    if ((0, _is.isNull)(d)) {
      console.error('date is not valid: ', arg)
    }
    _this._date = (0, _is.isNull)(d) ? (0, _getters.getNow)() : d
    return _this
  }
  var _proto = TimeDate.prototype
  _proto._setValidDateBetweenMinMax = function _setValidDateBetweenMinMax(d) {
    var min = this.min,
      max = this.max
    if ((0, _is.isNull)(min) && (0, _is.isNull)(max)) return

    if ((0, _is.isNum)(min) && d.getTime() < min) {
      d.setTime(min)
      console.warn(d, ' is less then min value')
    }

    if ((0, _is.isNum)(max) && d.getTime() > max) {
      d.setTime(max)
      console.warn(d, ' is more then max value')
    }
  }
  _proto._emitChange = function _emitChange(partName) {
    if ((0, _is.isStr)(partName)) {
      this.emit('change:' + partName, {
        date: this.date,
        partName: partName,
        partValue: this.get(partName)
      })
    } else {
      this.emit('change', { date: this.date })
    }
  }
  _proto.get = function get(type) {
    return (0, _getters.get)(this.date, type)
  }
  _proto.setDate = function setDate(arg) {
    var d = _convert.default.fromWhatever(arg)
    if (!(0, _is.isNull)(d)) {
      this._setValidDateBetweenMinMax(d)
      this._date = d
      this._emitChange()
    }
  }
  _proto.setPart = function setPart(partName, val) {
    var isPartNameMonth = partName === 'M'
    var dateBeforeSet = this.get('d')
    var monthBeforeSet = isPartNameMonth ? val : this.get('M')
    var needToCheckDate = (isPartNameMonth || partName === 'y') && dateBeforeSet > 28

    ;(0, _setters.set)(this.date, partName, val)
    if (needToCheckDate && dateBeforeSet !== this.get('d')) {
      ;(0, _setters.set)(this.date, 'd', 1)
      ;(0, _setters.set)(this.date, 'M', monthBeforeSet)
      ;(0, _setters.set)(this.date, 'd', this.lastDateInMonth)
    }
    this._setValidDateBetweenMinMax(this.date)
    this._emitChange(partName)
    this._emitChange()
  }
  _proto.move = function move(partName, num) {
    ;(0, _utils.move)(this.date, partName, num)
    this._setValidDateBetweenMinMax(this.date)
    this._emitChange(partName)
    this._emitChange()
  }
  _proto.setPartWithotCheckingDate = function setPartWithotCheckingDate(partName, val) {
    ;(0, _setters.set)(this.date, partName, val)
    this._setValidDateBetweenMinMax(this.date)
    this._emitChange(partName)
    this._emitChange()
  }
  _proto.setParts = function setParts(args) {
    var _this2 = this
    var d = _convert.default.fromObj(args, this.date)
    if (d === null) {
      return
    }
    this._setValidDateBetweenMinMax(d)
    this._date = d
    Object.keys(args).forEach(function(partName) {
      _this2._emitChange(partName)
    })
    this._emitChange()
  }
  _proto.setTimePartToStartEnd = function setTimePartToStartEnd(partName, startOrEnd) {
    var d = (0, _setTimePartToStartEnd2.default)(this.date, partName, startOrEnd)
    this._setValidDateBetweenMinMax(d)
    this._date = d
    this._emitChange()
  }

  // setTimeToNow() {

  // }
  _proto.destroy = function destroy() {
    this.off()
  }
  ;(0, _createClass2.default)(TimeDate, [
    {
      key: 'date',
      get: function get() {
        return (0, _misc.isDate)(this._date) ? this._date : (0, _getters.getNow)()
      }
    },
    {
      key: 'ts',
      get: function get() {
        return this.date.getTime()
      }
    },
    {
      key: 'tsInSec',
      get: function get() {
        return _convert.default.tsToSec(this.ts)
      }
    },
    {
      key: 'objHms',
      get: function get() {
        return (0, _getters.getHmsFromDate)(this.date)
      }
    },
    {
      key: 'objDmy',
      get: function get() {
        return (0, _getters.getDmyFromDate)(this.date)
      }
    },
    {
      key: 'objDate',
      get: function get() {
        return (0, _getters.getObjDateFromDate)(this.date)
      }
    },
    {
      key: 'min',
      get: function get() {
        return this._min
      },
      set: function set(arg) {
        if (arg === null) {
          this._min = null
          ;(0, _innerUtils.clearDateObj)(this.minObj)
          return
        }
        var d = _convert.default.fromWhatever(arg)
        if ((0, _is.isNull)(d)) return
        this._min = d.getTime()
        ;(0, _innerUtils.fillDateObj)(this.minObj, d, TimeDate.fullSegmentsOpt)
        this._setValidDateBetweenMinMax(d)
        if (d.getTime() !== this.date.getTime()) {
          this._emitChange()
        }
      }
    },
    {
      key: 'max',
      get: function get() {
        return this._max
      },
      set: function set(arg) {
        if (arg === null) {
          this._max = null
          ;(0, _innerUtils.clearDateObj)(this.maxObj)
          return
        }
        var d = _convert.default.fromWhatever(arg)
        if ((0, _is.isNull)(d)) return
        this._max = d.getTime()
        ;(0, _innerUtils.fillDateObj)(this.maxObj, d, TimeDate.fullSegmentsOpt)
        this._setValidDateBetweenMinMax(d)
        if (d.getTime() !== this.date.getTime()) {
          this._emitChange()
        }
      }
    },
    {
      key: 'lastDateInMonth',
      get: function get() {
        return (0, _utils.getLastDateInMonth)(this.date)
      }
    }
  ])
  return TimeDate
})(_EventEmitter2.default)
exports.default = TimeDate
;(0, _defineProperty2.default)(TimeDate, 'fullSegmentsOpt', { date: true, time: true, seconds: true })



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/TimeDate.js
// module id = 217
// module chunks = 0